/* Built In Imports*/
import { useEffect } from 'react';
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components  */
import config from '@config';

/* Services */
/**
 * Renders the US ChatBot Component
 *
 * @param
 * @returns {ReactElement} - US Chat Bot Component
 */
const HealthFreshChat = () => {
  useEffect(() => {
    // Define the pre-chat template and fcSettings before loading the widget
    window.preChatTemplate = {
      mainbgColor: '#000084',
      maintxColor: '#fff',
      heading: 'Isha Health',
      textBanner: 'We can\'t wait to talk to you. But first, please take a couple of moments to tell us a bit about yourself.',
      SubmitLabel: 'Start Chat',
      fields: {
        field2: {
          type: "name",
          label: "Name",
          fieldId: "name",
          required: "no",
          error: "Please Enter a valid name"
        },
        field3: {
          type: "email",
          label: "Email",
          fieldId: "email",
          required: "no",
          error: "Please Enter a valid Email"
        },
        field4: {
          type: "phone",
          label: "Phone",
          fieldId: "phone",
          required: "no",
          error: "Please Enter a valid Phone Number"
        },
        field5: {
          type: "dropdown",
          label: "Consultation Type",
          fieldId: "consultationType",
          required: "yes",
          error: "Please select a consultation type",
          options: [
            "In-Person Consultation",
            "Online Consultation",
            "General",
            "Online Obesity Treatment Program",
            "Residential Programs"
          ]
        }
      }
    };

    window.fcSettings = {
      token: "1cefb6e2-f5fa-4e56-9abd-393e9708ffc4",
      host: "https://ishasupport.freshchat.com",
      widgetUuid: "e06f0b26-02a6-48ce-8f16-25c82f8af508",
      config: {
        cssNames: {
          widget: 'custom_fc_frame',
          expanded: 'custom_fc_expanded'
        }
      },
      onInit: function () {
        console.log('widget init');
        window.fcPreChatform.fcWidgetInit(window.preChatTemplate);
      }
    };

    // Load pre-chat form script
    const preChatScript = document.createElement("script");
    preChatScript.src = "https://snippets.freshchat.com/js/fc-pre-chat-form-v2.min.js";
    preChatScript.async = false;
    document.body.appendChild(preChatScript);

    // Load main widget script after pre-chat form
    const widgetScript = document.createElement("script");
    widgetScript.src = "https://ishasupport.freshchat.com/js/widget.js";
    widgetScript.async = true;
    document.body.appendChild(widgetScript);

    // Dropdown listener logic
    const attachDropdownListener = () => {
      const dropdown = document.querySelector('select[id="chat-fc-consultationtype"]');
      if (dropdown) {
        dropdown.addEventListener('change', function () {
          const selectedValue = dropdown.value;
          if (selectedValue && selectedValue !== "...") {
            const slugifiedValue = selectedValue.toLowerCase().replace(/ /g, '_').replace(/-/g, '_');
            window.fcWidget.user.setProperties({
              consultationType: slugifiedValue
            });
          }
        });
        return true;
      }
      return false;
    };

    const observer = new MutationObserver((mutations, obs) => {
      if (attachDropdownListener()) {
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup
    return () => {
      document.body.removeChild(preChatScript);
      document.body.removeChild(widgetScript);
      observer.disconnect();
    };
  }, []);

  return null;
};

export default HealthFreshChat;
